window.addEventListener('OpusCartChange', (event)=>{
  const data = event.detail;
  const sectionCustom = document.querySelector('#opus-price-ct-container');
  if(sectionCustom){
    sectionCustom.remove()
  }

  const checkoutBtn = document.querySelector("#opus-checkout-btn-2");
       checkoutBtn?.insertAdjacentHTML(
            "beforebegin",
            `<div id="opus-price-ct-container" style="width: 100%; display: flex; flex-direction: column; font-size: 1.3em; padding-top: 10px; ">
                <div style="width: 100%; display: flex; padding-top: 1px; justify-content: space-between; font-weight: bold; gap: 10px; margin: auto;">
                    <span style="flex-shrink: 0; align-items: center;">
                    <strong>Summe</strong>
                    </span>
                    
                    <div style="display: flex; gap: 5px; justify-content: center; align-items: center;">
                    <span>${data.money}</span>
                    </div>
                </div>
            </div>`
        );

});
